import { css } from '@emotion/css';

export const noHorizontalScrollbarsCss = css`
  overflow: -moz-scrollbars-none; /* Hide scroll bar in Firefox */
  -ms-overflow-style: none; /* Hide scroll bar in IE */
  ::-webkit-scrollbar {
    width: 0 !important; /* Hide scrollbar in Webkit browsers */
  }
`;
